import { render } from "./BSChart.vue?vue&type=template&id=0143a8a3"
import script from "./BSChart.vue?vue&type=script&lang=js"
export * from "./BSChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__